import React, { createContext, useCallback, useState } from "react";
import Alert from "../components/Alert";

const initialAlertState = {
  visible: false,
  title: "Atenção",
  message: "",
  confirmText: "OK",
  cancelText: "",
  onConfirm: null,
  onCancel: null,
  hideCloseButton: false,
};

export const AlertContext = createContext({
  showAlert: () => null,
  hideAlert: () => null,
});

export function AlertProvider({ children }) {
  const [alertState, setAlertState] = useState(initialAlertState);

  const hideAlert = useCallback(() => {
    setAlertState({
      ...initialAlertState,
      visible: false,
    });
  }, []);

  const showAlert = useCallback((config) => {
    setAlertState((prevState) => ({
      ...prevState,
      ...config,
      visible: true,
    }));
  }, []);

  const handleCancel = () => {
    if (typeof alertState.onCancel === "function") {
      alertState.onCancel();
    }
    hideAlert();
  };

  const handleConfirm = () => {
    if (typeof alertState.onConfirm === "function") {
      alertState.onConfirm();
    }
    hideAlert();
  };

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}
      <Alert
        visible={alertState.visible}
        title={alertState.title}
        message={alertState.message}
        confirmText={alertState.confirmText}
        cancelText={alertState.cancelText}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        hideCloseButton={alertState.hideCloseButton}
      />
    </AlertContext.Provider>
  );
}
